import React, { useMemo } from 'react';
import { getTrackingOp, useTrackingOp } from '../../../../contexts/TrackingOpContext';
import { OPERATION_TYPE, STEP_KEY_V2 } from "../../../../util/varibles/constants";
import Event from "./Event";
import Harvest2 from "./Harvest2";
import Service from "./Service";
import Service2 from "./Service2";
import stylesOp from "./style.module.scss";
import Support from "./Support";
import Transport from "./Transport";
import Treatment from "./Treatment";
import Treatment2 from './Treatment2';

const Body: React.FC = React.memo(() => {
    const get = getTrackingOp();

    const View = useMemo(() => {
        const { op } = get();
        const { operation, activity_log = [] } = op || {};
        const { operation_type } = operation || {};
        switch (operation_type) {
            case OPERATION_TYPE.HARVEST:
                return Harvest2;
            case OPERATION_TYPE.EVENT:
                return Event;
            case OPERATION_TYPE.TREATMENT: {
                const indexes = new Set<number>([0, 1, 2]);
                const index = activity_log.findIndex(item => item.key === STEP_KEY_V2.TREATING)
                if (indexes.has(index))
                    return Treatment2;
                return Treatment;
            }
            case OPERATION_TYPE.TRANSPORT:
                return Transport;
            case OPERATION_TYPE.SERVICE:
                if (activity_log.length > 2)
                    return Service2;
                return Service;
            case OPERATION_TYPE.SUPPORT:
                return Support;
            default:
                return () => null;
        }
    }, [get]);
    return <View />
}, () => true);

const Operation: React.FC = React.memo(() => {
    const [active] = useTrackingOp(state => state.active);

    return <div className={stylesOp.wrapper} data-active={active}>
        <Body />
    </div>
}, () => true);

export default Operation;